import { classNames } from "@helpers/css";

const heightClassName = "h-14";
const measurementCellClassName = "text-center px-2 w-36 flex-none";

export const measurementRowCellClassName = classNames(
  measurementCellClassName,
  heightClassName,
  "py-2 text-gray-500 text-center border-b border-r border-gray-300 text-sm",
);
